import { createActions } from "redux-actions";
import * as actionTypes from "./actionTypes";
import { Patient, Person } from "../../models/models";

export {
    auth,
    authFail,
    authStart,
    authSuccess,
    setAuthRedirectPath,
    authCheckState,
    logout
} from './auth'

// patient actions
export const {
    findPatients, loadPatient, findPatientsSucceed, loadPatientDetails, loadPatientDetailsSucceed,
    showPatientDetails, hidePatientDetails, updatePatient, resetPatients
} = createActions({
    [actionTypes.FIND_PATIENTS]: null,
    [actionTypes.LOAD_PATIENT]: null,
    [actionTypes.FIND_PATIENTS_SUCCEED]: null,
    [actionTypes.LOAD_PATIENT_DETAILS]: null,
    [actionTypes.LOAD_PATIENT_DETAILS_SUCCEED]: patient => Object.assign(new Patient(), patient),
    [actionTypes.SHOW_PATIENT_DETAILS]: null,
    [actionTypes.HIDE_PATIENT_DETAILS]: null,
    [actionTypes.UPDATE_PATIENT]: (id, patientData) => ({ id, patientData }),
    [actionTypes.RESET_PATIENTS]: null
});

// therapies actions
export const {
    showVisitDetails, hideVisitDetails, addNewVisit, changeCalendarDate, setCalendarDate,
    loadTherapists, loadTherapistsSucceed,
    loadVisits, loadVisitsSucceed, cancelVisit, saveTherapy, updateTherapyTerm,
    setErrorMessage, setConflictedTerms
} = createActions({
    [actionTypes.SHOW_VISIT_DETAILS]: null,
    [actionTypes.HIDE_VISIT_DETAILS]: null,
    [actionTypes.ADD_NEW_VISIT]: null,

    [actionTypes.CHANGE_CALENDAR_DATE]: null,
    [actionTypes.SET_CALENDAR_DATE]: null,

    [actionTypes.LOAD_THERAPISTS]: null,
    [actionTypes.LOAD_THERAPISTS_SUCCEED]: (therapists) => therapists.map(therapist => Object.assign(new Person(), therapist)),

    [actionTypes.LOAD_VISITS]: null,
    [actionTypes.LOAD_VISITS_SUCCEED]: null,
    [actionTypes.CANCEL_VISIT]: (id, paid, permanent) => ({ id, paid, permanent }),

    [actionTypes.SAVE_THERAPY]: null,
    [actionTypes.UPDATE_THERAPY_TERM]: (id, therapyData) => ({ id, therapyData }),

    [actionTypes.SET_ERROR_MESSAGE]: null,
    [actionTypes.SET_CONFLICTED_TERMS]: null,
});

// reports actions
export const {
    startLoadingData, toggleReportsActionBar, setReportsPeriod, setVisitsIdsForReports, loadVisitsReportData, loadVisitsReportDataSucceed,
    loadPatientsReportData, loadPatientsReportDataSucceed, massActionOnVisits
} = createActions({
    [actionTypes.START_LOADING_DATA]: null,
    [actionTypes.TOGGLE_REPORTS_ACTION_BAR]: null,
    [actionTypes.SET_REPORTS_PERIOD]: null,
    [actionTypes.SET_VISITS_IDS_FOR_REPORTS]: null,
    [actionTypes.LOAD_VISITS_REPORT_DATA]: null,
    [actionTypes.LOAD_VISITS_REPORT_DATA_SUCCEED]: null,
    [actionTypes.LOAD_PATIENTS_REPORT_DATA]: null,
    [actionTypes.LOAD_PATIENTS_REPORT_DATA_SUCCEED]: null,
    [actionTypes.MASS_ACTION_ON_VISITS]: null
});


// WEBPACK FOOTER //
// ./src/store/actions/index.js